import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FirAnalyzeCurrentTaxesService {
  constructor(private http: HttpClient) {}

  loadComments(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.postForm(url, {
      action_code: 'mg9894',
      ...params,
    });
  }

  saveComment(baseUrl: string, rowData: any, comment: string, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=babj7u`;

    const jsonObj = [
      {
        combination_key: rowData?.COMBINATION_KEY,
        chart_key: rowData?.CHART_KEY,
        trans_header_key: rowData?.SIGNOFF_TRANS_HEADER_KEY || 0,
        issue_key: rowData?.ISSUE_KEY,
        comments: (comment || '').replace(/’/g, "'"),
      },
    ];

    const jsonSetting = [
      {
        combination_key: rowData?.COMBINATION_KEY,
        tax_year: rowData?.TAX_YEAR,
      },
    ];

    let params = _.merge({}, globalService || {}, filterParams || {});
    params = _.extend({ jsonObj: JSON.stringify(jsonObj) }, params);
    params = _.extend({ jsonSetting: JSON.stringify(jsonSetting) }, params);
    params.process_name = 'AnalyzeCommentsSave';

    return this.postForm(url, params);
  }

  private postForm(url: string, params: any): Observable<any> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, String(value));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post<any>(url, urlEncoded.toString(), {
      headers,
      withCredentials: true,
    });
  }
}
